import { Link } from "react-router-dom";
import portfolioImage from "../../assets/HomeImages/datacenter.webp";
import { trackEvent } from "../../utils/analytics";
import Eyebrow from "../common/Eyebrow";
import Reveal from "../common/Reveal";

const CAPABILITIES = [
  "Enterprise data center colocation & hosting",
  "Dedicated servers & cloud infrastructure",
  "IT hardware procurement & leasing",
  "24/7 monitoring, security & compliance support",
];

const HomePortfolio = () => {
  return (
    <section className="bg-white px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal direction="left">
            <div>
              <Eyebrow>Our work</Eyebrow>
              <h2 className="mt-3 text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">
                Discover our capabilities
              </h2>
              <p className="mt-5 max-w-xl leading-relaxed text-slate-600">
                Explore how QuantaRock designs secure infrastructure, scalable cloud services, and managed IT solutions for growing enterprises.
              </p>
              <ul className="mt-6 space-y-2 text-sm text-slate-700">
                {CAPABILITIES.map((line) => (
                  <li key={line} className="flex gap-2">
                    <span className="text-[var(--website-secondary-color)]">&#10003;</span>
                    {line}
                  </li>
                ))}
              </ul>
              <div className="mt-7 flex flex-wrap items-center gap-4">
                <a
                  href="/quantarock_portfolio.pdf"
                  download
                  className="inline-block"
                  onClick={() =>
                    trackEvent("file_download", { file_name: "quantarock_portfolio.pdf" })
                  }
                >
                  <span className="inline-flex rounded-full bg-[var(--website-primary-color)] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[var(--primary-hover)]">
                    Download portfolio
                  </span>
                </a>
                <Link
                  to="/contact"
                  className="text-sm font-semibold text-[var(--website-primary-color)] underline decoration-[var(--website-secondary-color)] underline-offset-4 transition hover:text-[var(--primary-hover)]"
                >
                  Talk to an expert
                </Link>
              </div>
            </div>
          </Reveal>

          <Reveal direction="right">
            <div className="group overflow-hidden rounded-3xl border border-slate-200 bg-slate-50 p-3 shadow-sm transition duration-300 hover:border-[rgba(var(--website-secondary-rgb),0.6)] hover:shadow-lg">
              <div className="overflow-hidden rounded-2xl">
                <img
                  src={portfolioImage}
                  alt="QuantaRock engineers working in our data center"
                  className="h-auto w-full rounded-2xl transition duration-300 group-hover:scale-105"
                  loading="lazy"
                  width={1600}
                  height={873}
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default HomePortfolio;
